import type { EffectsView } from '../../game/gameView';

export interface EffectsLayer extends EffectsView {
  readonly element: HTMLElement;
  destroy(): void;
}

const FLOATER_DURATION_MS = 900;
const BURST_DURATION_MS = 600;
const BURST_PETAL_DEGREES = [0, 60, 120, 180, 240, 300] as const;

export function createEffectsLayer(): EffectsLayer {
  const root = document.createElement('div');
  root.className = 'effects-layer';
  const timers = new Set<number>();

  function scheduleRemoval(node: HTMLElement, ms: number): void {
    const id = window.setTimeout(() => {
      timers.delete(id);
      node.remove();
    }, ms);
    timers.add(id);
  }

  function spawnFloater(x: number, y: number, text: string, color: string): void {
    const el = document.createElement('div');
    el.className = 'effect-floater headline';
    el.style.left = `${x}px`;
    el.style.top = `${y}px`;
    el.style.color = color;
    el.textContent = text;
    root.appendChild(el);
    scheduleRemoval(el, FLOATER_DURATION_MS);
  }

  function spawnBurst(x: number, y: number, color: string): void {
    const el = document.createElement('div');
    el.className = 'effect-burst';
    el.style.left = `${x}px`;
    el.style.top = `${y}px`;

    const halo = document.createElement('div');
    halo.className = 'effect-burst-halo';
    halo.style.background = color;
    el.appendChild(halo);

    for (const deg of BURST_PETAL_DEGREES) {
      const petal = document.createElement('div');
      petal.className = 'effect-burst-petal';
      petal.style.background = color;
      petal.style.setProperty('--burst-angle', `${deg}deg`);
      el.appendChild(petal);
    }

    root.appendChild(el);
    scheduleRemoval(el, BURST_DURATION_MS);
  }

  function destroy(): void {
    for (const id of timers) clearTimeout(id);
    timers.clear();
    root.remove();
  }

  return { element: root, spawnFloater, spawnBurst, destroy };
}
